import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  timeout: 10000,
});

// Adjuntar token JWT en cada petición
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Si el token expira → redirigir al login (con guard para evitar loops)
let redirecting = false;
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !redirecting) {
      // Solo redirigir si NO es una ruta de recursos secundarios (plantillas, etc.)
      const url = err.config?.url || '';
      const esRutaSecundaria = url.includes('plantillas') || url.includes('medicamentos');
      if (!esRutaSecundaria) {
        redirecting = true;
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
